import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'

export default function useFixiOSBug() {
  const store = useStore()
  const subMenu = ref<any>(null)
  
  const device = computed(() => store.state.app.device)
  
  onMounted(() => {
    // 修复iOS设备上点击菜单触发mouseleave的bug
    fixBugIniOS()
  })
  
  const fixBugIniOS = () => {
    if (subMenu.value) {
      const handleMouseleave = subMenu.value.handleMouseleave
      if (handleMouseleave) {
        subMenu.value.handleMouseleave = (e: MouseEvent) => {
          if (device.value === 'mobile') {
            return
          }
          handleMouseleave(e)
        }
      }
    }
  }
  
  return {
    subMenu,
    fixBugIniOS
  }
}